import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
import { reviews } from '../data/testimonials';
export function Testimonials() {
  return <section className="bg-cream py-16 sm:py-20" aria-labelledby="reviews-title" data-id="element-248" data-mp="3fznsli0714zs">
      <div className="mx-auto max-w-6xl px-4" data-id="element-249" data-mp="3fxkx4ig9ujno">
        <h2 id="reviews-title" className="text-center text-3xl font-extrabold text-forest-950 sm:text-4xl" data-id="element-250" data-mp="3b1chl3y5wofz">
          Testimonios de docentes que ya tienen su Megapack
        </h2>

        <div className="mt-10 grid gap-5 md:grid-cols-3" data-id="element-251" data-mp="31zd2wiamdwg7">
          {reviews.map(([initials, name, role, quote], index) => <motion.article key={name} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.15
        }} transition={{
          duration: 0.3,
          delay: index * 0.05,
          ease: [0.23, 1, 0.32, 1]
        }} className="flex flex-col rounded-xl border border-earth-200 bg-white p-6 shadow-sm shadow-earth-900/5" data-id="element-252" data-mp="2x1kzar0m4lw6" data-mpi={index}>
              <div className="flex text-gold-500" aria-label="5 de 5 estrellas" data-id="element-253" data-mp="h4n44cnfo1bg">
                {Array.from({
              length: 5
            }, (_, star) => <StarIcon key={star} className="h-4 w-4 fill-current" aria-hidden="true" data-id="element-254" data-mp="78abli3mjtia" />)}
              </div>
              <blockquote className="mt-4 flex-1 leading-relaxed text-earth-900" data-id="element-255" data-mp="c7mxo0mo8wjt">“{quote}”</blockquote>
              <div className="mt-6 flex items-center gap-3 border-t border-earth-100 pt-4" data-id="element-256" data-mp="zxqyk08h6i74">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-forest-800 text-sm font-extrabold text-gold-300" data-id="element-257" data-mp="14uhi4xjhnvxa">
                  {initials}
                </span>
                <span data-id="element-258" data-mp="v4epiyga4jzh">
                  <b className="block text-sm text-forest-950" data-id="element-259" data-mp="v3wm9hv795i2">{name}</b>
                  <small className="text-xs text-earth-500" data-id="element-260" data-mp="1iuifw44gin8j">{role}</small>
                </span>
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}